// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { signInCreateNewAccountStyles } from "@insite/content-library/Widgets/SignIn/SignInCreateNewAccount";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import resolveColor from "@insite/mobius/utilities/resolveColor";
import { css } from "styled-components";

signInCreateNewAccountStyles.checkoutAsGuestButton = {
    variant: "primary",
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        width: 100%;
                        margin-bottom: 20px;
                    `,
                    css`
                        width: auto;
                        margin-right: 10px;
                    `,
                    null,
                    null,
                    null,
                ],
                "min",
            )}
    `,
};

signInCreateNewAccountStyles.createNewAccountButton = {
    ...signInCreateNewAccountStyles.createNewAccountButton,

    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        width: 100%;
                    `,
                    css`
                        width: auto;
                    `,
                    null,
                    null,
                    null,
                ],
                "min",
            )}
    `,
};

signInCreateNewAccountStyles.signInCreateNewAccountButtonGridItem = {
    ...signInCreateNewAccountStyles.signInCreateNewAccountButtonGridItem,
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: row;
                        justify-content: flex-start;
                    `,
                    null,
                    null,
                    null,
                ],
                "min",
            )}
    `,
};

signInCreateNewAccountStyles.signInCreateNewAccountGridContainer = {
    ...signInCreateNewAccountStyles.signInCreateNewAccountGridContainer,
    css: css`
        ${signInCreateNewAccountStyles.signInCreateNewAccountGridContainer?.css};

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        border-top: 1px solid ${resolveColor("common.border", theme)};
                        margin-top: 10px;
                        padding-top: 30px;
                    `,
                    null,
                    null,
                    null,
                ],
                "max",
            )}
    `,
};
